import { RichAssetDatePicker, RichAssetTimePicker, RichAssetFileUpload, isRichAssetPersistentMenu, } from '../../generated/ast.js';
import { RichAssetTypesDisplayNames } from '../../common/mappings.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateAnswerRequiredField(node, nodeFields, accept) {
    const { idField, nodeTypeField, answerRequiredField, richAssetField } = nodeFields;
    // answerRequired is only for decision nodes
    if (nodeTypeField?.nodeType?.value !== 'D')
        return;
    // If answerRequired is not present, then it defaults to false
    const answerRequired = answerRequiredField?.answerRequired || 'false';
    if (richAssetField &&
        [
            RichAssetDatePicker.$type,
            RichAssetTimePicker.$type,
            RichAssetFileUpload.$type,
        ].indexOf(richAssetField?.content?.$type) !== -1) {
        // answerRequired must be set to true for these rich assets
        if (answerRequired !== 'true') {
            accept('error', `'answerRequired' must be set to true when ${RichAssetTypesDisplayNames[richAssetField.content.$type]} is specified.`, {
                node: answerRequiredField || node,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.ANSWER_REQUIRED,
                },
            });
        }
    }
    else if (richAssetField &&
        isRichAssetPersistentMenu(richAssetField?.content)) {
        // answerRequired must be set to false for this rich asset
        if (answerRequired !== 'false') {
            accept('error', `'answerRequired' must be set to false when ${RichAssetTypesDisplayNames[richAssetField.content.$type]} is specified.`, {
                node: answerRequiredField || node,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.ANSWER_REQUIRED,
                },
            });
        }
    }
}
//# sourceMappingURL=validate-answer-required.js.map